module.exports = __webpack_public_path__ + "application/templates/default/inner/processes/inner/processes-create/processes-create.template.html";